<script setup lang="ts">
import { groupByScreen } from '@cockpit/shared';
import { computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { NOUVEAUTES_PATH, whatsNewHeading } from '../../nouveautes';
import { useNouveautesStore } from '../../stores/nouveautes';
import ChangeList from './ChangeList.vue';
import '../../styles/nouveautes.css';

/**
 * Lot BA, maquette « Dans l'appli » repère 2 : « Quoi de neuf » en bas à droite, NON BLOQUANT (pas de voile, pas de
 * piège du focus). Plusieurs versions depuis le dernier passage : regroupées et rangées par écran.
 */
const store = useNouveautesStore();
const router = useRouter();
const route = useRoute();
const grouped = computed(() => groupByScreen(store.whatsNew));
const heading = computed(() => whatsNewHeading(store.whatsNew));

// Sur la page Nouveautés, on voit déjà tout : le popup se ferme et la version est notée comme vue.
watch(
  () => [route.name, store.whatsNewOpen] as const,
  ([name, open]) => {
    if (name === 'nouveautes' && open) void store.dismissWhatsNew();
  },
  { immediate: true },
);

async function seeAll(): Promise<void> {
  void store.dismissWhatsNew();
  await router.push(NOUVEAUTES_PATH);
}
</script>

<template>
  <div
    v-if="store.whatsNewOpen && store.whatsNew.length"
    class="nv-whatsnew"
    role="dialog"
    aria-modal="false"
    aria-labelledby="nv-whatsnew-title"
    data-testid="whats-new"
    @keydown.esc.stop="store.dismissWhatsNew()"
  >
    <div class="nv-wn-head">
      <div>
        <div class="nv-wn-ver">{{ heading }}</div>
        <h3 id="nv-whatsnew-title">Quoi de neuf</h3>
      </div>
      <button
        class="nv-x"
        type="button"
        aria-label="Fermer"
        data-testid="whats-new-close"
        @click="store.dismissWhatsNew()"
      >
        ×
      </button>
    </div>
    <div class="nv-wn-body">
      <ChangeList :screens="grouped" :heading-level="4" />
    </div>
    <div class="nv-wn-foot">
      <button class="linkish" type="button" data-testid="whats-new-all" @click="seeAll">
        Toutes les nouveautés
      </button>
      <button
        class="btn sm primary"
        type="button"
        data-testid="whats-new-seen"
        @click="store.dismissWhatsNew()"
      >
        J'ai vu
      </button>
    </div>
  </div>
</template>
